<template>
  <div class="component-carousel-slider pt-md-0 pt-2">
    <b-carousel
      :interval="4000"
      controls
      indicators
    >
      <b-link
        v-for="(image, index) in items"
        :key="index"
        :href="getTargetUrlType(image.targetUrl) === 'href' ? image.targetUrl : ''"
        :to="getTargetUrlType(image.targetUrl) === 'route' ? image.targetUrl : ''"
        :target="getTargetUrlType(image.targetUrl) === 'href' ? '_blank' : '_self'"
        @click="trackGaEvent(image.isMain,image.targetUrl)"
      >
        <b-carousel-slide
          :img-src="fileUrl(image.src)"
        >
        </b-carousel-slide>
     </b-link>
    </b-carousel>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import windowSize from '@/mixins/window-size'

  export default {
    name: 'CarouselSlider',
    mixins: [windowSize],
    props: {
      items: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      ...mapGetters({
        fileUrl: 'cdn/fileUrl'
      })
    },
    methods: {
      getTargetUrlType(src) {
        if (src.startsWith('http')) {
          return 'href'
        }
        return 'route'
      },
      trackGaEvent(isMainImage, imageTargetUrl) {
        if (isMainImage) {
          this.$ga.event('Collection', 'SliderBigClick', imageTargetUrl)
        } else {
          this.$ga.event('Collection', 'SliderSmallClick', imageTargetUrl)
        }
      }
    }
  }
</script>
